module.exports = __webpack_public_path__ + "img/bg_chess_04.9a886403.jpg";